/* eslint-disable array-callback-return*/

import { Grid, Paper, TableCell, TableRow, Tooltip } from "@material-ui/core"
import {
  DatatablesFooterServerSide,
  IconButtonDatatable,
  InputTextMaster,
  Loading,
  MasterButton,
  Modal,
  ModalDeleteConfirm,
  TableAction,
} from "App/Component/ui"
import { getComparator, stableSort } from "App/Component/ui/datatable/utils"
import { useDatatables, useDatatablesServerSide } from "App/hooks"
import {
  defaultDateDisplay,
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  formatRupiah,
  isNull,
} from "App/utils/helpers"
import React, { useEffect, useState } from "react"
import { FreezeTable } from "components/organism"
import {
  STATE_FILTER_DETAIL_PEMBAYARAN,
  bayarDetailTagihan,
  deleteDetailPembayaranByID,
  getDetailBayarRekapTagihan,
  headCellsDetailPembayaran,
} from "../helpers"
import { RenderStatusPembelian } from "App/Component/layout/Penjualan/DaftarPenjualan/helpers"
import { DISABLED_BUTTON_SUBMIT } from "App/constants"
import FormFilterDetailPembayaran from "./FormFilterDetailPembayaran"
import { Sync } from "@material-ui/icons"
import { getDetailPembayaranById } from "../../helpers"

const SHOW_RESTART_BUTTON = {
  label: "JALANKAN PEMBAYARAN",
  color: "#296218",
  state: false,
  disabled: false,
}

const ModalDetailPembayaran = ({
  setShowModal,
  dataPembayaran,
  setDataPembayaran,
  formData,
  setNewData,
}) => {
  const [rowsBayar, setRowsBayar] = useState([])
  const [totalDataBayar, setTotalBayar] = useState(0)
  const [dataAntrian, setDataAntrian] = useState([])
  const [totalDataAntrian, setTotalDataAntrian] = useState(0)
  const [loading, setLoading] = useState(false)
  const [loadingAntrian, setLoadingAntrian] = useState(false)
  const [formFilter, setFormFilter] = useState(STATE_FILTER_DETAIL_PEMBAYARAN)
  useEffect(() => {
    setFormFilter({
      ...STATE_FILTER_DETAIL_PEMBAYARAN,
      id_bayar_rekap: dataPembayaran.id,
      status: 1,
    })
    fetchDataBayar({
      ...STATE_FILTER_DETAIL_PEMBAYARAN,
      id_bayar_rekap: dataPembayaran.id,
      status: 1,
    })
    fetchDataAntrian()
  }, [dataPembayaran]) // eslint-disable-line react-hooks/exhaustive-deps

  const fetchDataBayar = async (formFilter, pages = 1, limit = 10) => {
    setLoading(true)
    const api = await getDetailBayarRekapTagihan(formFilter, pages, limit)
    if (api.state) {
      if (pages === 1) {
        paginationsLunas.setPagination({
          count: api.meta.count,
          limit: limit,
          pages: pages,
        })
      }
      setRowsBayar(api.data)
      setTotalBayar(api.meta.count)
    } else {
      setRowsBayar([])
      setTotalBayar(0)
      defaultToastError(api.message)
    }
    setLoading(false)
  }

  const fetchDetailPembayaran = async () => {
    try {
      console.log("TEST")

      const response = await getDetailPembayaranById(
        formData.rekap_tagihan_id,
        1,
        1,
        dataPembayaran.id,
      )

      if (response.state) {
        setDataPembayaran(response.data[0])
      } else {
        defaultToastError(response.message)
      }
    } catch (error) {
      setLoading(false)
      defaultToastError(error?.response?.data?.message)
    }
  }

  const fetchDataAntrian = async (pages = 1, limit = 10) => {
    setLoadingAntrian(true)
    const api = await getDetailBayarRekapTagihan(
      {
        ...STATE_FILTER_DETAIL_PEMBAYARAN,
        id_bayar_rekap: dataPembayaran.id,
        status: 0,
      },
      pages,
      limit,
    )
    if (api.state) {
      if (pages === 1) {
        paginationsBelumLunas.setPagination({
          count: api.meta.count,
          limit: limit,
          pages: pages,
        })
      }
      setDataAntrian(api.data)
      setTotalDataAntrian(api.meta.count)
    } else {
      setDataAntrian([])
      setTotalDataAntrian(0)
      defaultToastError(api.message)
    }
    setLoadingAntrian(false)
  }

  const refresh = () => {
    fetchDetailPembayaran()
    fetchDataBayar(formFilter)
    fetchDataAntrian()
  }

  const paginationsLunas = useDatatablesServerSide({
    setNewData: fetchDataBayar,
  })
  const paginationsBelumLunas = useDatatablesServerSide({
    setNewData: fetchDataAntrian,
  })

  return (
    <>
      <Modal
        title={"Detail Pembayaran"}
        width="96%"
        maxWitdh="96%"
        show={setShowModal}
      >
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <Header
              totalDataAntrian={totalDataAntrian}
              dataBayar={dataPembayaran}
              refresh={refresh}
              dataAntrian={dataAntrian}
              loadingAntrian={loadingAntrian}
            />
          </Grid>
          <Grid item md={8} sm={12}>
            <TableDataBayar
              fetchDataBayar={fetchDataBayar}
              loading={loading}
              rowsBayar={rowsBayar}
              totalDataBayar={totalDataBayar}
              refresh={refresh}
              formFilter={formFilter}
              setFormFilter={setFormFilter}
              paginations={paginationsLunas}
            />
          </Grid>
          <Grid item md={4} sm={12}>
            <TableDataAntrian
              fetchDataAntrian={fetchDataAntrian}
              loading={loadingAntrian}
              setLoading={setLoadingAntrian}
              rowsAntrian={dataAntrian}
              totalDataAntrian={totalDataAntrian}
              refresh={refresh}
              dataBayar={dataPembayaran}
              paginations={paginationsBelumLunas}
              setNewData={setNewData}
            />
          </Grid>
        </Grid>
      </Modal>
    </>
  )
}

const Header = ({
  totalDataAntrian,
  dataBayar,
  refresh,
  dataAntrian,
  loadingAntrian,
}) => {
  return (
    <>
      <Grid container spacing={1}>
        <Grid item sm={12}>
          <Grid container spacing={1} justifyContent="flex-start">
            <MasterButton
              type="button"
              color={"green"}
              name={"REFRESH"}
              onClick={() => refresh()}
              size="md"
            />
          </Grid>
        </Grid>

        <Grid item sm={4}>
          <InputTextMaster
            name="id"
            label="ID BAYAR"
            id="id"
            value={dataBayar?.id}
            placeholder="ID"
            disabled={true}
          />
        </Grid>
        <Grid item sm={4}>
          <InputTextMaster
            name="tgl"
            label="TANGGGAL"
            id="tgl"
            value={defaultDateDisplay(dataBayar?.tanggal_masuk, true)}
            placeholder="Tanggal"
            disabled={true}
          />
        </Grid>
        <Grid item sm={4}>
          <InputTextMaster
            name="jumlah_bayar"
            label="JUMLAH BAYAR"
            id="jumlah_bayar"
            readOnly={true}
            disabled={true}
            value={formatRupiah(dataBayar?.jumlah_bayar)}
            placeholder="Jumlah Bayar"
            withButtonLeft={true}
          >
            <button
              type={"button"}
              onClick={null}
              style={{
                borderLeft: "1px solid #EAEAEA",
                borderTop: "1px solid #EAEAEA",
                borderBottom: "1px solid #EAEAEA",
                borderRight: "0",
                background: "#f7f7f7",
                padding: "0 0 0 0.8rem",
                cursor: "pointer",
                borderRadius: "6px 0 0 6px",
                fontSize: "10px",
              }}
            >
              Rp.
            </button>
          </InputTextMaster>
        </Grid>

        <Grid item sm={4}>
          <InputTextMaster
            name="total_diskon"
            label="DISKON"
            id="total_diskon"
            readOnly={true}
            disabled={true}
            value={formatRupiah(dataBayar?.total_diskon)}
            placeholder="Jumlah Bayar"
            withButtonLeft={true}
          >
            <button
              type={"button"}
              onClick={null}
              style={{
                borderLeft: "1px solid #EAEAEA",
                borderTop: "1px solid #EAEAEA",
                borderBottom: "1px solid #EAEAEA",
                borderRight: "0",
                background: "#f7f7f7",
                padding: "0 0 0 0.8rem",
                cursor: "pointer",
                borderRadius: "6px 0 0 6px",
                fontSize: "10px",
              }}
            >
              Rp.
            </button>
          </InputTextMaster>
        </Grid>
        <Grid item sm={4}>
          <InputTextMaster
            name="jumlah_ref"
            label="JUMLAH REF"
            id="jumlah_ref"
            readOnly={true}
            disabled={true}
            value={formatRupiah(
              dataBayar?.jumlah_bayar + dataBayar?.total_diskon,
            )}
            placeholder="Jumlah REF"
            withButtonLeft={true}
          >
            <button
              type={"button"}
              onClick={null}
              style={{
                borderLeft: "1px solid #EAEAEA",
                borderTop: "1px solid #EAEAEA",
                borderBottom: "1px solid #EAEAEA",
                borderRight: "0",
                background: "#f7f7f7",
                padding: "0 0 0 0.8rem",
                cursor: "pointer",
                borderRadius: "6px 0 0 6px",
                fontSize: "10px",
              }}
            >
              Rp.
            </button>
          </InputTextMaster>
        </Grid>
        <Grid item sm={4}>
          <InputTextMaster
            name="status"
            label="STATUS PEMBAYARAN"
            id="sisa_pembayaran"
            readOnly={true}
            disabled={true}
            value={
              loadingAntrian
                ? "-"
                : dataAntrian.length === 0
                ? "Lunas"
                : "Belum Lunas"
            }
            placeholder="Sisa Pembayaran"
          />
        </Grid>
      </Grid>
    </>
  )
}

const TableDataBayar = ({
  loading,
  rowsBayar,
  fetchDataBayar,
  totalDataBayar,
  refresh,
  formFilter,
  setFormFilter,
  paginations,
}) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rowsBayar,
    orderByDefault: "sisa_tagihan",
    orderByRow: [
      "sisa_tagihan",
      "id_tagihan",
      "nama_rm",
      "rm_id",
      "nama_asuransi",
      "no_asuransi",
    ],
  })

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = paginations

  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false)
  const [tagihanID, setTagihanID] = useState({
    tagihan_id: "",
    id_bayar_rekap: "",
  })

  const clickDelete = async (row) => {
    setTagihanID({
      tagihan_id: row?.id_tagihan,
      id_bayar_rekap: row?.id_bayar_rekap,
    })
    setShowModalDeleteConfirm(!showModalDeleteConfirm)
  }

  async function deleteList() {
    const res = await deleteDetailPembayaranByID(tagihanID)
    if (res.state) {
      defaultToastSuccess(res.message)
      await refresh()
      setTagihanID({
        tagihan_id: "",
        id_bayar_rekap: "",
      })
    } else {
      defaultToastError(res.message)
    }

    setShowModalDeleteConfirm(false)
  }

  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
          title={"Hapus Pembayaran Tagihan Ini"}
          msg={"Apakah anda yakin ingin menghapus data pembayaran ini ?"}
        />
      )}
      <div className="mt-1">
        <Paper className="p-1">
          <Loading show={loading} />
          <FormFilterDetailPembayaran
            fetchDataBayar={fetchDataBayar}
            formFilter={formFilter}
            setFormFilter={setFormFilter}
          />
          <FreezeTable
            headCells={headCellsDetailPembayaran}
            handleRequestSort={handleRequestSort}
            order={order}
            length={length}
            orderBy={orderBy}
          >
            {stableSort(rowsBayar, getComparator(order, orderBy)).map(
              (row, index) => {
                return (
                  <TableRow hover tabIndex={-1} key={index}>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell>
                      <TableAction
                        isUpdate={false}
                        isDelete={true}
                        clickDelete={() => clickDelete(row)}
                      />
                    </TableCell>
                    <TableCell align="left">{row?.id_tagihan}</TableCell>
                    <TableCell align="left">{row?.nama_rm}</TableCell>
                    <TableCell align="left">{row?.rm_id}</TableCell>
                    <TableCell align="center">
                      <RenderStatusPembelian status={row?.status_pembayaran} />
                    </TableCell>
                    <TableCell align="left">
                      {defaultDateDisplay(row?.tanggal_tagihan, true)}
                    </TableCell>
                    <TableCell align="left">
                      {isNull(row?.nama_asuransi) ? "-" : row?.nama_asuransi}
                    </TableCell>
                    <TableCell align="left">
                      {isNull(row?.no_asuransi) ? "-" : row?.no_asuransi}
                    </TableCell>
                    <TableCell align="right">
                      {formatNumber(row?.totaltagihan)}
                    </TableCell>
                    <TableCell align="right">
                      {formatNumber(row?.total_bayar)}
                    </TableCell>
                    <TableCell align="right">
                      {formatNumber(row?.sisa_tagihan)}
                    </TableCell>
                    {rowsBayar.length === 0 && (
                      <TableCell
                        align="center"
                        rowSpan={headCellsDetailPembayaran.length}
                      >
                        Tidak Ada Data
                      </TableCell>
                    )}
                  </TableRow>
                )
              },
            )}
          </FreezeTable>
          <DatatablesFooterServerSide
            totalData={totalDataBayar}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </Paper>
      </div>
    </>
  )
}

const TableDataAntrian = ({
  setLoading,
  loading,
  rowsAntrian,
  fetchDataAntrian,
  totalDataAntrian,
  refresh,
  dataBayar,
  paginations,
  setNewData,
}) => {
  const [disabledRestart, setDisabledRestart] = useState(SHOW_RESTART_BUTTON)

  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rowsAntrian,
    orderByDefault: "id_tagihan",
    orderByRow: ["sisa_tagihan", "id_tagihan", "nama_rm"],
  })

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
    resetPagination,
  } = paginations

  const headCells = [
    {
      id: "no",
      disablePadding: false,
      label: "NO",
      align: "center",
      sort: false,
      width: "50px",
    },
    {
      id: "tagihan_id",
      disablePadding: true,
      label: "ID TAGIHAN",
      sort: false,
      align: "left",
      minWidth: "100px",
    },
    {
      id: "nama_rm",
      disablePadding: true,
      label: "NAMA",
      sort: false,
      align: "left",
      minWidth: "180px",
    },
    {
      id: "sisa",
      disablePadding: true,
      label: "SISA",
      sort: false,
      align: "left",
      minWidth: "150px",
    },
  ]

  const jalanKanRekrusif = async () => {
    setLoading(true)
    setDisabledRestart(DISABLED_BUTTON_SUBMIT)

    const res = await bayarDetailTagihan(dataBayar.id)
    if (res.state) {
      defaultToastSuccess(res.message)
      resetPagination()
      fetchDataAntrian()
      setNewData()
      setTimeout(refresh(), 1000)
    } else {
      defaultToastError(res.message)
      setLoading(false)
    }
    setDisabledRestart(SHOW_RESTART_BUTTON)
  }

  return (
    <>
      <div className="mt-1">
        <Paper className="p-1">
          <Grid container spacing={1}>
            <Grid item md={12}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "7px",
                  width: "100%",
                  marginBottom: "50px",
                }}
              >
                <button
                  type="button"
                  disabled={disabledRestart.state}
                  onClick={
                    totalDataAntrian.length > 0
                      ? null
                      : () => jalanKanRekrusif()
                  }
                  style={{
                    background:
                      totalDataAntrian.length > 0
                        ? "#D8D8D8"
                        : disabledRestart.color,
                    display: "block",
                    width: "100%",
                    color: "white",
                    border: 0,
                    borderRadius: "4px",
                    fontWeight: "600",
                    padding: "0.6rem 2rem",
                    fontSize: "15px",
                    marginTop: "25px",
                    cursor: "pointer",
                    marginBottom: "25px",
                  }}
                  className={`button-login`}
                >
                  {disabledRestart.label}
                </button>

                <IconButtonDatatable
                  style={{
                    backgroundColor: "#296218",
                    padding: "1.3rem 2rem",
                  }}
                  onClick={() => {
                    resetPagination()
                    fetchDataAntrian()
                  }}
                >
                  <Tooltip title={"Perbarui Data"} aria-label="update">
                    <Sync fontSize={"large"} style={{ color: "#fff" }} />
                  </Tooltip>
                </IconButtonDatatable>
              </div>
            </Grid>
          </Grid>
          <Loading show={loading} />
          {/* <TableToolbar title="">
            <MasterButton
              type="button"
              color={disabledRestart.color}
              name={DISABLED_BUTTON_SUBMIT.label}
              onClick={() => jalanKanRekrusif()}
              size="md"
              disabled={disabledRestart.state}
            />
          </TableToolbar> */}
          <FreezeTable
            headCells={headCells}
            handleRequestSort={handleRequestSort}
            order={order}
            length={length}
            orderBy={orderBy}
          >
            {stableSort(rowsAntrian, getComparator(order, orderBy)).map(
              (row, index) => {
                return (
                  <TableRow hover tabIndex={-1} key={index}>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell align="left">{row?.id_tagihan}</TableCell>
                    <TableCell align="left">{row?.nama_rm}</TableCell>
                    <TableCell align="right">
                      {formatNumber(row?.sisa_tagihan)}
                    </TableCell>
                    {rowsAntrian.length === 0 && (
                      <TableCell align="center" rowSpan={headCells.length}>
                        Tidak Ada Data
                      </TableCell>
                    )}
                  </TableRow>
                )
              },
            )}
          </FreezeTable>
          <DatatablesFooterServerSide
            totalData={totalDataAntrian}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </Paper>
      </div>
    </>
  )
}

export default ModalDetailPembayaran
